import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../SvgProps';

const Recorder = ({ color = '#000000', bgColor =  '#D0D0D0'}: Props) => (
  <Svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <Path
      d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
      fill={bgColor}
    />
    <Path
      d="M16 21.834V24.334"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M21.8332 14.334V16.0007C21.8332 17.5477 21.2186 19.0315 20.1246 20.1254C19.0307 21.2194 17.5469 21.834 15.9998 21.834C14.4527 21.834 12.969 21.2194 11.875 20.1254C10.7811 19.0315 10.1665 17.5477 10.1665 16.0007V14.334"
       stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M18.5 10.166C18.5 8.7853 17.3807 7.66602 16 7.66602C14.6193 7.66602 13.5 8.7853 13.5 10.166V15.9993C13.5 17.3801 14.6193 18.4993 16 18.4993C17.3807 18.4993 18.5 17.3801 18.5 15.9993V10.166Z"
       stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default Recorder;
